import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Award } from "lucide-react";
import api from "../../api";

export default function LoyaltyCard() {
  const [tiers, setTiers] = useState(null);
  useEffect(() => { api.get("/loyalty").then(r => setTiers(t => t || r.data.tiers)).catch(() => {}); }, []);

  const set = (i, k, v) => setTiers(ts => ts.map((t, j) => j === i ? { ...t, [k]: k === "visits" ? Number(v) : v } : t));
  const save = async () => {
    try { await api.put("/admin/loyalty", { tiers }); toast.success("Recompensas atualizadas para todas as clientes"); }
    catch (e) { toast.error(e.response?.data?.detail || "Não foi possível salvar"); }
  };

  return (
    <div className="card-arya p-6" data-testid="loyalty-card">
      <div className="flex items-center gap-2 mb-3"><Award size={16} className="text-[color:var(--sun-600)]"/><h3 className="font-serif text-xl">Recompensas por visitas</h3></div>
      <div className="space-y-3">
        {!tiers && <p className="text-sm text-[color:var(--ink-500)]">Carregando...</p>}
        {(tiers || []).map((t, i) => (
          <div key={i} className="flex flex-wrap items-center gap-2" data-testid={`loyalty-tier-${i}`}>
            <input type="number" min="1" max="50" value={t.visits} onChange={e => set(i, "visits", e.target.value)}
                   className="w-16 rounded-lg border border-[var(--line)] bg-white px-2 py-2 text-sm" data-testid={`loyalty-visits-${i}`}/>
            <span className="text-xs">visitas</span>
            <textarea rows={2} value={t.reward} onChange={e => set(i, "reward", e.target.value)} placeholder="Recompensa"
                   className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid={`loyalty-reward-${i}`}/>
          </div>
        ))}
      </div>
      <button onClick={save} disabled={!tiers} className="btn-gold !py-2 !px-4 text-sm mt-4" data-testid="loyalty-save">Salvar recompensas</button>
      <p className="text-[10px] text-[color:var(--ink-500)] mt-2">Aparece no perfil de todas as clientes.</p>
    </div>
  );
}
